import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "../AdminImage/logo-light-icon.png";
import config from "../../../function/config";
import axios from "axios";
import admin from "../AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

export default function FloatingCraneA() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const {id} = useParams()

  const [allShips, setallShips] = useState([]);
  const [allCategory, setallCategory] = useState([]);
  const [allSubCategory, setallSubCategory] = useState([]);
  const [input, setInput] = useState('');
  const [count, setCount] = useState(0);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            
          }
        );
        if (res1.data.status === 200) {
          console.log("Sub_Category Data:",res1);
          setallSubCategory(res1.data.data);
        } else {
          console.log("error");
        }
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log("Category Data :",res2);
          setallCategory(res2.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // Fetch Customer Registered Ships
 
  
const location = useLocation();


  const [allShipsReg, setallShipsReg] = useState([]);
    const [selectedVesselType, setSelectedVesselType] = useState('');
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

 const [currentPage, setCurrentPage] = useState(1);
  const [refPage, setRefPage] = useState(1);

 const combinedShips = [...allShips, ...allShipsReg]
  .filter(ship => ship.created_at) // Ensure created_at exists
  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest




// Pagination logic
  const itemsPerPage = 30;
  


  // Calculate total pages
  const totalPages = Math.ceil((allShips.length + allShipsReg.length) / itemsPerPage);
 // Paginated data
  const startIndex = (currentPage - 1) * itemsPerPage;  
 

 // Fetch ships
useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          title: input,
        },
      });

      if (res1.data.status === 200) {
        console.log(res1);
        
        if (res1.data.data.length < 7) {
          setCurrentPage(1);
        }
        
        if (input === "") {
          setCurrentPage(refPage);
        }

        // Filter ships where vessel_type is "Cargo" and sort by latest created_at
        let sortedShips = res1.data.data
          .filter(ship => ship.vessel_type === "Floating Crane" && ship.created_at) // Ensure it's Floating Crane and has created_at
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setallShips(sortedShips.reverse());
      } else {
        console.log("Error fetching ships");
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchData();
}, [config.base_url, input, currentPage, refPage]);

// Fetch ships
useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          short_description: input,
        },
      });

      if (res1.data.status === 200) {
        console.log(res1);
        
        if (res1.data.data.length < 7) {
          setCurrentPage(1);
        }
        if (input === "") {
          setCurrentPage(refPage);
        }

        // Filter ships where vessel_type is "Floating Crane" and is_allow is true
        let filteredShipsReg = res1.data.data
          .filter(ship => ship.is_allow && ship.vessel_type === "Floating Crane") // Only Cargo ships that are allowed
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest created_at

        setallShipsReg(filteredShipsReg.reverse());
      } else {
        console.log("Error fetching ships");
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();
}, [config.base_url, input, currentPage, refPage]);

  useEffect(() => {
  if (input === "" && allShips.length > 0 && allShipsReg.length > 0) {
    setCurrentPage(refPage);
  } else if (sortedData.length < 7) {
    setCurrentPage(1);
  }
}, [input, allShips, allShipsReg]);


const filteredAllShipsReg = input.trim()
  ? allShipsReg
      .filter((ship) => ship.is_allow && ship.short_description?.toLowerCase().includes(input.toLowerCase()))
      .map((ship) => ({ ...ship, isFromReg: true }))
  : allShipsReg
      .filter((ship) => ship.is_allow)
      .map((ship) => ({ ...ship, isFromReg: true }));

const filteredAdminShips = input.trim()
  ? allShips.filter((ship) =>
      ship.short_description?.toLowerCase().includes(input.toLowerCase())
    )
  : allShips;

const allShipsWithFlag = filteredAdminShips.map((ship) => ({
  ...ship,
  isFromReg: false,
}));

// Merge and sort ships by created_at (latest first)
const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
);

// Pagination Logic for Combined Data
const totalCombinedPages = Math.ceil(sortedData.length / itemsPerPage);
const paginatedShips = sortedData.slice(startIndex, startIndex + itemsPerPage);

 

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShipsReg.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
};

  

  const [allImages,setAllImages] = useState([])

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :",res3);
          setAllImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url,count]);


  const [allImagesReg,setAllImagesReg] = useState([])
  
    useEffect(() => {
      async function fetchdata() {
        try {
          const res3 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }
            }
          );
          if (res3.data.status === 200) {
            console.log("Images :",res3);
            setAllImagesReg(res3.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url,count]);

  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${config.base_url}/api/HappyMarineShipping/deleteShip/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCount(id);
        console.log(response);
        toast.success("Ship Deleted Successfully !", {
          autoClose: 1000,
          position: "top-right",
        });
      } else {
        console.log("error1");
        toast.error("Error", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const token = localStorage.getItem("token");

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setRefPage(page); // Update reference page
      setCurrentPage(page); // Update state (reactive)
      
    }
  };

  const handleStatus = async (id)=>{
    const data={
    }
    try {
        const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/status/update/${id}`, data, {
            headers: {
                'Authorization': `Token ${token}`
            }
        });

        if (response.data.status === 200) {
           console.log("Success")
           setCount(count +1)
            toast.success("Disabled Succesfully",{
                       autoClose:1500,
                       position:'top-right',
                       
                     });
        } else {
            console.log("Error while marking as completed");
        }
    } catch (err) {
        console.log("Error:", err);
    }
}

const handleStatusD = async (id)=>{
  const data={
  }
  try {
      const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/statusD/update/${id}`, data, {
          headers: {
              'Authorization': `Token ${token}`
          }
      });

      if (response.data.status === 200) {
         console.log("Success")
         setCount(count +1)
          toast.success(" Enabled Successfully!",{
                     autoClose:1500,
                     position:'top-right',
                     
                   });
      } else {
          console.log("Error while marking as completed");
      }
  } catch (err) {
      console.log("Error:", err);
  }
}

const handleStatusReg = async (id)=>{
  const data={
  }
  try {
      const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/status/update/reg/${id}`, data, {
          headers: {
              'Authorization': `Token ${token}`
          }
      });

      if (response.data.status === 200) {
         console.log("Success")
         setCount(count +1)
          toast.success("Disabled Succesfully",{
                     autoClose:1500,
                     position:'top-right',
                     
                   });
      } else {
          console.log("Error while marking as completed");
      }
  } catch (err) {
      console.log("Error:", err);
  }
}

const handleStatusDReg = async (id)=>{
  const data={
  }
  try {
      const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/statusD/update/reg/${id}`, data, {
          headers: {
              'Authorization': `Token ${token}`
          }
      });

      if (response.data.status === 200) {
         console.log("Success")
         setCount(count +1)
          toast.success(" Enabled Successfully!",{
                     autoClose:1500,
                     position:'top-right',
                     
                   });
      } else {
          console.log("Error while marking as completed");
      }
  } catch (err) {
      console.log("Error:", err);
  }
}

const handleDeleteReg = async (id) => {
    try {
      const response = await axios.delete(
        `${config.base_url}/api/HappyMarineShipping/deleteShipForSale/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCount(id);
        console.log(response);
        toast.success("Ship Deleted Successfully !", {
          autoClose: 1000,
          position: "top-right",
        });
      } else {
        console.log("error1");
        toast.error("Error", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

 

  const cleanHiddenDetails = (text) => {
    return text?.replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, ''); // Removes LRM, RLM, RLE, LRE, etc.
  };


const handleVesselChange = (e) => {
  const value = e.target.value;

  // Define your navigation logic
  if (value === 'All') {
    navigate('/admin/viewShip');
  }
  if(value === 'Barge'){
    navigate('/admin/Barge');
  }
  if(value === 'Bulk'){
    navigate('/admin/Bulk');
  }
if(value === 'Cargo'){
    navigate('/admin/Cargo');
  }
if(value === 'Container'){
    navigate('/admin/Container');
  }
if(value === 'Fishing'){
    navigate('/admin/Fishing');
  }
if(value === 'Multipurpose'){
    navigate('/admin/Multipurpose');
  }
if(value === 'Passenger/Ferry'){
    navigate('/admin/Passenger/Ferry');
  }
if(value === 'Reefer'){
    navigate('/admin/Reefer');
  }if(value === 'RoRo'){
    navigate('/admin/Roro');
  }if(value === 'Tanker'){
    navigate('/admin/Tanker');
  }if(value === 'Dredger'){
    navigate('/admin/Dredger');
  }if(value === 'Floating Crane'){
    navigate('/admin/Floating/Crane');
  }if(value === 'Floating Dock'){
    navigate('/admin/Floating/Dock');
  }if(value === 'Landing Craft'){
    navigate('/admin/Landing/Craft');
  }
  if(value === 'Yatch'){
    navigate('/admin/Yatch');
  }if(value === 'Tug Boat'){
    navigate('/admin/Tug/Boat');
  }if(value === 'Supply Boat'){
    navigate('/admin/Supply/Boat');
  }
  if(value === 'Crew Boat'){
    navigate('/admin/Crew/Boat');
  }
  if(value === 'Other'){
    navigate('/admin/Other');
  }

  
  

};

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* center p-3 Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
                       <div
                         className={`${
                           isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
                         }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
                       >
                         <ul className="mt-10 flex flex-col gap-3 ">
                           {/* Dashboard */}
                           <li className="px-4 py-2 text-lg   flex items-center">
                             <i className="fa-solid fa-gauge mr-3"></i>
                             {isSidebarOpen && <Link to="/admin/dashboard">Dashboard</Link>}
                           </li>
               
                           {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
               
                           {/* Ship For Sale Dropdown */}
                           <li className="px-2 text-[#00c292] border-l-4 border-[#00c292]  text-lg  flex flex-col  relative">
                             <div
                               className="flex items-center  justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                             >
                               <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Ship For Sale</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 1 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 py-1  hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 1
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4  py-1 hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-2  text-lg flex flex-col relative">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Ship For Charter</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
                             {!isSidebarOpen && openDropdown === 2 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 2
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                            <li className="px-2 text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                  <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Logistics </span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 3 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >Add logistics</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >View Logistics</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 3
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >Add Logistics</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >View Logistics</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-2  text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                  <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Supply Equipments </span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 4 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 4
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
                            
                          {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
                                                           {isSidebarOpen && <ul className="px-2  text-lg flex flex-col relative group">
                                                      <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforsale"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ships For Sale
                                                       </Link>
                                                       {newShip && (
                                                         <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                           New
                                                         </span>
                                                       )}
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforCharterApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ship For Charter
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Logistics
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforEqApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Supply Equipments
                                                       </Link>
                                                     </li>
                                                     
                                                     
                                                   </ul>}
               
                           {/* Settings Dropdown */}
                           <li className="px-3 py-2 text-lg flex flex-col relative group">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                               onClick={() => toggleDropdown(6)}
                             >
                               <div className="flex items-center gap-2">
                                 <i className="fa-solid fa-gear"></i>
                                 {isSidebarOpen && <span>Settings</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {/* Hover Dropdown (Closed Sidebar) */}
                             {!isSidebarOpen && openDropdown === 6 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                 <ul>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                   <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Click Dropdown (Open Sidebar) */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 6
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
                         </ul>
                       </div>
               
                       {/* mobile screen sidebar */}
               
                       <div
                         className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
                           isMobile
                             ? isSidebarOpen
                               ? "w-full translate-x-0" // Open in full width on mobile
                               : "-translate-x-full w-0" // Hide sidebar on mobile
                             : isSidebarOpen
                             ? "w-60 translate-x-0" // Open normally on desktop
                             : "w-0" // Hide sidebar on desktop
                         }`}
                       >
                         <ul className="mt-10 flex flex-col gap-3 ">
                           {/* Dashboard */}
                           <li className={`px-4 py-2 text-lg    flex items-center`}>
                             {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
                             {isSidebarOpen && <Link to="/admin/dashboard">Dashboard</Link>}
                           </li>
               
                          {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                           {/* Ship For Sale Dropdown */}
                           <li
                             className={`px-2  text-lg text-[#00c292] border-l-4 border-[#00c292] flex flex-col  relative`}
                           >
                             <div
                               className="flex items-center  justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                             >
                               <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                 {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Ship For Sale</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 1 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 py-1  hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 1
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4  py-1 hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-3  text-lg flex flex-col relative">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Ship For Charter</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
                             {!isSidebarOpen && openDropdown === 2 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 2
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                            <li className="px-3  text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Logistics</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 3 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >Add logistics</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >View Logistics</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 3
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >Add Logistics</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link >View logistics</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-3  text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Supply Equipments</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 4 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 4
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                             <li className="px-3 text-lg flex flex-col relative group">
                                               {/* Clickable Div */}
                                              {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
                                             
                                                           {isSidebarOpen && <ul className="px-2 py-2  text-lg flex gap-3
                                                            flex-col relative group">
                                                      <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforsale"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ships For Sale
                                                       </Link>
                                                       {newShip && (
                                                         <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                           New
                                                         </span>
                                                       )}
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforCharterApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ship For Charter
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Logistics
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforEqApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Supply Equipments
                                                       </Link>
                                                     </li>
                                                     
                                                     
                                                   </ul>
                                               }
                                             
                                               {/* Click Dropdown (For open sidebar) */}
                                               {isSidebarOpen && (
                                                 <div
                                                   className={`ml-6 mt-2 transition-all duration-300 ${
                                                     openDropdown === 5
                                                       ? "max-h-48 opacity-100 "
                                                       : "max-h-0 opacity-0 overflow-hidden"
                                                   }`}
                                                 >
                                                  <ul>
                                                      <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforsale"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ships For Sale
                                                       </Link>
                                                       {newShip && (
                                                         <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                           New
                                                         </span>
                                                       )}
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforCharterApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Ship For Charter
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                       <Link
                                                         
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Logistics
                                                       </Link>
                                                       
                                                     </li>
                                                     
                                                      <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                       <Link
                                                         to="/admin/shipforEqApp"
                                                         onClick={() => handleView()} // Ensure it runs before navigation
                                                       >
                                                        - Supply Equipments
                                                       </Link>
                                                     </li>
                                                     
                                                     
                                                   </ul>
                                                 </div>
                                               )}
                                             </li>
                                  
               
                           {/* Settings Dropdown */}
                           <li className="px-3  text-lg flex flex-col relative group">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                               onClick={() => toggleDropdown(6)}
                             >
                               <div className="flex items-center gap-2">
                                 {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                                 {isSidebarOpen && <span>Settings</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {/* Hover Dropdown (Closed Sidebar) */}
                             {!isSidebarOpen && openDropdown === 6 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                 <ul>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Click Dropdown (Open Sidebar) */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 6
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
                         </ul>
                       </div>
        {/* Main Content */}
        <div className="flex-1 overflow-auto py-4">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
            <div className="flex justify-between items-center">
              <h1>View Ship</h1>
              <div className="flex text-sm gap-2">
                <p><Link to={'/adminHome'}>Home</Link></p> <span>/</span>
                <p className="text-[#00c292]">View Ship</p>
              </div>
            </div>

          </div>

          <div className="w-full  py-5 px-4">
              <div className="bg-white overflow-auto w-full max-w-full  p-6 mt-5 rounded">
                <div className="flex gap-5 ">
                  <div className="py-3">
                    <input
                      type="text"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      placeholder="Search Ship"
                      className="rounded-lg   p-2 border shadow"
                    />
                  </div>
  
                   <div className="py-3">
                   
                  <select
      className="rounded-lg text-gray-500 p-2 border shadow"
      name="vesselType"
      id="VesselType"
      onChange={handleVesselChange}
    >
      <option hidden value="">-Select Vessel-</option>
      <option disabled className="text-gray-500 font-semibold" value="">
        Categories
      </option>
      <option value="All">All Ships</option>
      <option value="Barge">Barge</option>
      <option value="Bulk">Bulk</option>
      <option value="Cargo">Cargo</option>
      <option value="Container">Container</option>
      <option value="Fishing">Fishing</option>
      <option value="Multipurpose">Multipurpose</option>
      <option value="Passenger/Ferry">Passenger/Ferry</option>
      <option value="Reefer">Reefer</option>
      <option value="RoRo">RoRo</option>
      <option value="Tanker">Tanker</option>
      <option value="Dredger">Dredger</option>
      <option selected value="Floating Crane">Floating Crane</option>
      <option value="Floating Dock">Floating Dock</option>
      <option value="Landing Craft">Landing Craft</option>
      <option value="Yatch">Yacht</option>
      <option value="Tug Boat">Tug Boat</option>
      <option value="Supply Boat">Supply Boat</option>
      <option value="Crew Boat">Crew Boat</option>
      <option value="Other">Other</option>
    </select>

                  </div>
                </div>

                {/* Responsive Table Wrapper */}
                <div className="w-full lg:w-[1500px] shadow-lg rounded-lg overflow-auto">
                  <table className=" w-full  bg-white  shadow-lg rounded-lg overflow-auto">
                    <thead className="bg-gray-100 border-b  border-gray-200 rounded-lg">
                      <tr className="">
                        <th className="px-6 py-3 w-[100px] text-center text-gray-600">
                          Ref ID
                        </th>
                       
                        <th className=" p-3 lg:w-[80px] text-center text-gray-600">
                          Category
                        </th>
                        <th className=" p-3 lg:w-[80px] w-[150px] text-center text-gray-600">
                          Vessel Type
                        </th>
                        <th className=" p-3 text-center text-gray-600">
                          Short Description
                        </th>
                        <th className="p-3 text-center  text-gray-600">
                          Contact Info
                        </th>
                        <th className=" p-3 w-[150px] text-center text-gray-600">
                          Image
                        </th>
                        <th className=" p-3 text-center text-gray-600">
                          Status
                        </th>
                        <th className=" p-3 text-center text-gray-600">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    {paginatedShips.length === 0 && input==="" ? (
  <tr>
    <td colSpan="9" className="px-6 text-red-500 text-center py-4">
      Ship not Available
    </td>
  </tr>
) : (
  paginatedShips.map((itm, index) => {
   return(
     <tr key={itm.id} className="border-b p-3 border-gray-200">
      <td className="text-center text-sm py-5">{itm.ship_code} - {itm.id}</td>
      
      <td className=" text-sm text-center  py-3 ">
        {allCategory.find((cat) => cat.id === itm.main_category)
          ?.category_name || itm.main_category}
      </td>
      <td className=" text-sm text-center p-3 ">{itm.vessel_type}</td>
      <td className=" text-sm text-center p-3 ">{itm.short_description}</td>
      <td className=" text-sm text-center p-3">
      {(!itm.isFromReg && itm.hidden_details) ? `${cleanHiddenDetails(itm.hidden_details)} ` : ""}
  {(itm.email || itm.phone)
    ? `${itm.email || ""}${itm.email && itm.phone ? ", " : ""}${itm.phone || ""}`
    : (!itm.isFromReg && itm.hidden_details ? "" : "None")}
</td>

<td className=" text-center p-3">
  <div>
    {(() => {
      let imageSrc = null;

      if (itm.isFromReg) {
        // Customer-registered ship: use first uploaded image
        const regImages = allImagesReg.filter((img) => img.ships === itm.id);
        imageSrc = regImages[0]?.image;
      } else {
        // Admin ship: use first uploaded image (ignore thumbnail_image)
        const adminImages = allImages.filter((img) => img.ship === itm.id);
        imageSrc = adminImages[0]?.image;
      }

      return imageSrc ? (
        <img
          src={imageSrc}
          alt="Ship"
          className="rounded-md w-full h-[80px]"
        />
      ) : (
        <span className="text-gray-400 italic">No image available</span>
      );
    })()}
  </div>
</td>



<td className="text-center ">
  {itm.is_status === false ? (
    <button
      onClick={(e) => {
        e.preventDefault();
        if (itm.isFromReg) {
          handleStatusReg(itm.id); // ✅ Correct
        } else {
          handleStatus(itm.id); // ✅ Correct
        }
      }}
      className="bg-red-500 transition-all duration-300 hover:bg-red-400 rounded px-2 py-1 text-white"
    >
      Disable
    </button>
  ) : (
    <button
      onClick={(e) => {
        e.preventDefault();
        if (itm.isFromReg) {
          handleStatusDReg(itm.id); // ✅ FIXED HERE
        } else {
          handleStatusD(itm.id); // ✅ FIXED HERE
        }
      }}
      className="bg-[#00c292] transition-all duration-300 hover:bg-[#246656] rounded px-2 py-1 text-white"
    >
      Enable
    </button>
  )}
</td>

      <td className="py-5 text-center p-3">
        <div className="flex gap-4 sm:gap-8 items-center justify-center">
          <button
            className="text-blue-500 hover:underline"
            onClick={
              () =>{
                if(itm.isFromReg){
                  navigate(`/admin/updateViewShipCustomerRegister/${itm.id}`)
                }else{
                  navigate(`/admin/updateViewShip/${itm.id}`)
                }
                }
              } 
          >
            <i className="fa-solid fa-pen"></i>
          </button>
          <button
            onClick={() =>{
              if(itm.isFromReg){
                handleDeleteReg(itm.id)
              }else{
                handleDelete(itm.id)}
              }
            } 
            className="text-red-500 hover:underline"
          >
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      </td>
    </tr>
   )
})
)}

                    </tbody>
                  </table>
                </div>
                {/* pagination */}
                  {paginatedShips.length > 0 && (
  <div className="xm:mt-8 mt-5 flex justify-center items-center gap-3">
    <button
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className={`px-4 py-2 bg-[#00c292]  text-white rounded-sm ${
        currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-[#24806a]"
      }`}
    >
      <i className="fa-solid fa-chevron-left"></i>
    </button>

    <span className="px-4 py-2 bg-[#8D97AD] text-white rounded-sm">
      {currentPage}
    </span>

    <button
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalCombinedPages}
      className={`px-4 py-2 bg-[#00c292] text-white rounded-sm ${
        currentPage === totalCombinedPages ? "opacity-50 cursor-not-allowed" : "hover:bg-[#24806a]"
      }`}
    >
      <i className="fa-solid fa-chevron-right"></i>
    </button>
  </div>
)}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}
